<template>
    <div>
        <br>
        <v-container fluid class="py-15 px-16">
          <v-row align="start" class="flex-nowrap">
            <!-- Static Sidebar -->
            <v-col
              cols="4"
              class="d-flex"
              style="min-width: 230px; max-width: 320px;"
            >
              <v-card
                flat
                tile
                class="pa-6 elevation-1"
                style="width: 100%; border-radius: 12px;"
              >
                <h4 class="font-weight-bold mb-1 text-subtitle-1">Business Profile Setup</h4>
                <p class="text-caption mb-1">
                  Complete all sections to unlock Energy Audit and GHG Data Collection
                </p>

                <!-- Progreso -->
                <div class="text-caption font-weight-medium mb-2 grey--text">
                  {{ completedSteps }} of {{ steps.length }} sections complete
                </div>
                <v-progress-linear
                  :value="(completedSteps / steps.length) * 100"
                  height="6"
                  color="primary"
                  rounded
                  class="mb-4"
                />

                <!-- Lista de pasos -->
                <v-list nav class="setup-step-list">
                  <v-list-item
                    v-for="(item, index) in steps"
                    :key="index"
                    :active="currentStep === index"
                    @click="currentStep = index"
                    class="setup-step-item"
                    rounded
                  >
                    <v-list-item-icon>
                      <v-icon>{{ currentStep === index ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <div class="d-flex align-center">
                        <v-icon class="mr-1" color="primary">{{ item.icon }}</v-icon>
                        <span>{{ item.title }}</span>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

                <v-divider class="my-4"></v-divider>

                <div class="text-caption grey--text">
                  <v-icon small class="mr-1" color="green">mdi-check-circle</v-icon>
                  Business Info: Pending<br />
                  <v-icon small class="mr-1" color="green">mdi-check-circle</v-icon>
                  Sites: 0 defined<br />
                  <v-icon small class="mr-1" color="green">mdi-check-circle</v-icon>
                  GHG Categories: 0 selected
                </div>
              </v-card>
            </v-col>


                      <!-- Step Form -->
                      <v-col
              cols="8"
              class="d-flex justify-center"
              style="flex: 3 1 0;"
            >
              <v-card class="pa-6 elevation-1" max-width="750" style="border-radius: 12px;">
                <h3 class="mb-3 font-weight-medium text-h6">Company Profile</h3>
                <p class="text-body-2 mb-6">
                  Provide high-level information about your business to establish the foundation for energy and emissions tracking.
                </p>
                <v-form>
                  <v-row dense>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="companyProfile.companyName"
                        label="Company Name *"
                        placeholder="Enter your company's official name"
                        outlined dense
                        hide-details
                        class="modern-input"
                        background-color="#F3F3F5"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="companyProfile.annualProduction"
                        label="Annual Production *"
                        placeholder="e.g., 50,000 tons or 1,200,000 units"
                        hint="Needed for intensity KPIs (kg CO₂ / unit)"
                        persistent-hint
                        outlined dense
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="companyProfile.registrationNumber"
                        label="Registration Number"
                        placeholder="Tax ID, VAT, or business registration number"
                        hint="Optional – used for compliance audits"
                        persistent-hint
                        outlined dense
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="companyProfile.annualSales"
                        label="Annual Sales *"
                        placeholder="e.g., $120M or €85M"
                        hint="Used to calculate $/tCO₂ indicators"
                        persistent-hint
                        outlined dense
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-select
                        v-model="companyProfile.sector"
                        label="Sector *"
                        :items="['Energy', 'Technology', 'Agriculture', 'Transport']"
                        placeholder="Select your industry sector"
                        hint="Used to pull relevant benchmarks and KPIs"
                        persistent-hint
                        outlined dense
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-textarea
                        v-model="companyProfile.productDescription"
                        label="Product Description"
                        placeholder="Brief description of your main products or services"
                        hint="Optional – helps with context and reporting"
                        persistent-hint
                        outlined dense
                      />
                    </v-col>
                  </v-row>
                  <div class="text-right mt-6">
                    <v-btn color="grey darken-1" class="white--text px-8 py-2" rounded>
                      Next: Organizational Limits
                    </v-btn>
                  </div>
                </v-form>
              </v-card>
            </v-col>

          </v-row>
      </v-container>
    </div>
</template>

<script>
export default {
    name: 'ProfileUI',
    data: () => ({
    currentStep: 0,
    completedSteps: 0,
    steps: [
      { title: 'Company Profile', icon: 'mdi-office-building' },
      { title: 'Organizational Limits', icon: 'mdi-domain' },
      { title: 'Operational Limits', icon: 'mdi-tune' },
      { title: 'Boundary & Consolidation', icon: 'mdi-border-style' },
      { title: 'Reporting Period', icon: 'mdi-calendar-range' },
      { title: 'Responsibilities', icon: 'mdi-account-tie' },
      { title: 'Review & Launch', icon: 'mdi-rocket-launch' }
    ],
    companyProfile: {
      companyName: '',
      registrationNumber: '',
      sector: '',
      annualProduction: '',
      annualSales: '',
      productDescription: ''
    }
  }),
  methods: {
    nextStep() {
      if (this.currentStep < this.steps.length - 1) {
        if (this.currentStep + 1 > this.completedSteps) this.completedSteps++
        this.currentStep++
      }
    }
  }
}
</script>

<style scoped>
.v-list-item--active {
  background-color: #E3F2FD;
  border-radius: 8px;
}
.setup-step-item {
  min-height: 12px;
}
.setup-step-list .v-icon {
  font-size: 22px;
}
.modern-input .v-input__control {
  background-color: #f5f5f5 !important;
  border-radius: 12px !important;
  border: 1px solid #e0e0e0 !important;
  box-shadow: none !important;
  min-height: 48px;
}
.modern-input input {
  font-size: 14px;
  padding: 12px !important;
}
.modern-input .v-input__control {
  background-color: #f6f6f6;
  border-radius: 8px;
  border: 1px solid #dcdcdc;
}
@media (max-width: 960px) {
  .setup-step-list {
    font-size: 13px;
  }

  .setup-step-item span {
    white-space: normal;
    word-break: break-word;
  }
}
</style>